import { render, staticRenderFns } from "./studentCard.vue?vue&type=template&id=654ea9a7"
import script from "./studentCard.vue?vue&type=script&lang=js"
export * from "./studentCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports